var render = function render(_c,_vm){return _c('button',{staticClass:"location-select",class:[
    _vm.props.active && 'location-select--active',
    _vm.data.staticClass && `${_vm.data.staticClass}`,
    (_vm.data.staticClass && _vm.props.active) && `${_vm.className}--active`,
  ],on:{"click":function($event){$event.preventDefault();return _vm.listeners.click.apply(null, arguments)}}},[_c('span',{staticClass:"location-select__text"},[(_vm.props.name === 'GB')?[_vm._v("\n      UK\n    ")]:(_vm.props.name === 'US')?[_vm._v("\n      USA\n    ")]:[_vm._v("\n      "+_vm._s(_vm.props.name)+"\n    ")]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }